/** THIS IS AN AUTO GENERATED FILE, DO NOT EDIT MANUALLY -- Created by @graphql-codegen */
import * as Types from '../../shared/generated.types'

import { api } from '../../utils'
export const ServiceCategoryFragment = `
    fragment ServiceCategoryFragment on ServiceCategory {
  code
}
    `
export const ReferenceFragment = `
    fragment ReferenceFragment on Reference {
  _id
  type
  display
}
    `
export const AnnotationFragment = `
    fragment AnnotationFragment on Annotation {
  authorReference {
    ...ReferenceFragment
  }
  time
  text
}
    `
export const ScheduleFragment = `
    fragment ScheduleFragment on Schedule {
  _id
  active
  serviceCategory {
    ...ServiceCategoryFragment
  }
  actors {
    _id
    type
    display
  }
  reoccuranceTemplate {
    timezone
    reoccuranceType
    occuranceCount
    planningHorizon {
      startDate
      endDate
    }
    weeklyTemplate {
      offset
      interval
      dayTimes {
        startTime
        endTime
        dayOfWeek
      }
    }
  }
  notes {
    ...AnnotationFragment
  }
}
    `
export const ReoccuranceTemplateFragment = `
    fragment ReoccuranceTemplateFragment on ReoccuranceTemplate {
  id
  timezone
  reoccuranceType
  occuranceCount
  planningHorizon {
    startDate
    endDate
  }
  weeklyTemplate {
    offset
    interval
    dayTimes {
      startTime
      endTime
      dayOfWeek
    }
  }
  lastOccuranceIndex
}
    `
export const ServiceTypeFragment = `
    fragment ServiceTypeFragment on ServiceType {
  code
}
    `
export const VirtualServiceFragment = `
    fragment VirtualServiceFragment on VirtualService {
  channelType
  addressUrl
  phoneNumber
  sessionKey
}
    `
export const AppointmentFragment = `
    fragment AppointmentFragment on Appointment {
  _id
  status
  appointmentType
  description
  startDate
  endDate
  minutesDuration
  occuranceChanged
  occuranceIndex
  reoccuranceTemplate {
    ...ReoccuranceTemplateFragment
  }
  cancelationReason
  replacesAppointmentId
  createdDate
  serviceCategory {
    ...ServiceCategoryFragment
  }
  serviceType {
    ...ServiceTypeFragment
  }
  notes {
    ...AnnotationFragment
  }
  virtualService {
    ...VirtualServiceFragment
  }
  participants {
    actor {
      ...ReferenceFragment
    }
    type {
      code
    }
    required
    status
  }
  identifiers {
    source
    value
  }
  syncMessage
}
    `
export const AppointmentWarningFragment = `
    fragment AppointmentWarningFragment on AppointmentWarning {
  startDate
  endDate
  message
  code
}
    `
export const CreateAppointmentResponseFragment = `
    fragment CreateAppointmentResponseFragment on CreateAppointmentResponse {
  appointment {
    ...AppointmentFragment
  }
  warnings {
    ...AppointmentWarningFragment
  }
}
    `
export const UpdateReoccuranceTemplateResponseFragment = `
    fragment UpdateReoccuranceTemplateResponseFragment on UpdateReoccuranceTemplateResponse {
  reoccuranceTemplate {
    ...ReoccuranceTemplateFragment
  }
  warnings {
    ...AppointmentWarningFragment
  }
}
    `
export const CreateScheduleDocument = `
    mutation createSchedule($content: ScheduleInput!) {
  createSchedule(content: $content) {
    ...ScheduleFragment
  }
}
    ${ScheduleFragment}
${ServiceCategoryFragment}
${AnnotationFragment}
${ReferenceFragment}`
export const UpdateScheduleDocument = `
    mutation updateSchedule($id: ID!, $content: ScheduleInput!) {
  updateSchedule(_id: $id, content: $content) {
    ...ScheduleFragment
  }
}
    ${ScheduleFragment}
${ServiceCategoryFragment}
${AnnotationFragment}
${ReferenceFragment}`
export const DeleteScheduleDocument = `
    mutation deleteSchedule($id: ID!) {
  deleteSchedule(_id: $id) {
    _id
  }
}
    `
export const CreateAppointmentDocument = `
    mutation createAppointment($content: AppointmentInput!, $options: AppointmentOptions) {
  createAppointment(content: $content, options: $options) {
    ...AppointmentFragment
  }
}
    ${AppointmentFragment}
${ReoccuranceTemplateFragment}
${ServiceCategoryFragment}
${ServiceTypeFragment}
${AnnotationFragment}
${ReferenceFragment}
${VirtualServiceFragment}`
export const UpdateAppointmentDocument = `
    mutation updateAppointment($id: ID!, $content: UpdateAppointmentInput!, $options: AppointmentOptions) {
  updateAppointment(_id: $id, content: $content, options: $options) {
    ...AppointmentFragment
  }
}
    ${AppointmentFragment}
${ReoccuranceTemplateFragment}
${ServiceCategoryFragment}
${ServiceTypeFragment}
${AnnotationFragment}
${ReferenceFragment}
${VirtualServiceFragment}`
export const DeleteAppointmentDocument = `
    mutation deleteAppointment($id: ID!) {
  deleteAppointment(_id: $id) {
    _id
  }
}
    `
export const CreateAppointmentV2Document = `
    mutation createAppointmentV2($content: AppointmentInput!, $options: AppointmentOptions) {
  createAppointmentV2(content: $content, options: $options) {
    ...CreateAppointmentResponseFragment
  }
}
    ${CreateAppointmentResponseFragment}
${AppointmentFragment}
${ReoccuranceTemplateFragment}
${ServiceCategoryFragment}
${ServiceTypeFragment}
${AnnotationFragment}
${ReferenceFragment}
${VirtualServiceFragment}
${AppointmentWarningFragment}`
export const UpdateReoccuranceTemplateDocument = `
    mutation updateReoccuranceTemplate($id: ID!, $content: ReoccuranceTemplateInput!) {
  updateReoccuranceTemplate(id: $id, content: $content) {
    ...UpdateReoccuranceTemplateResponseFragment
  }
}
    ${UpdateReoccuranceTemplateResponseFragment}
${ReoccuranceTemplateFragment}
${AppointmentWarningFragment}`
export const GetScheduleDocument = `
    query getSchedule($_id: ID!) {
  getSchedule(_id: $_id) {
    ...ScheduleFragment
  }
}
    ${ScheduleFragment}
${ServiceCategoryFragment}
${AnnotationFragment}
${ReferenceFragment}`
export const SearchSchedulesDocument = `
    query searchSchedules($content: [SearchFilter!], $sort: [SortParam!], $searchAfter: AWSJSON, $pageSize: Int) {
  searchSchedules(
    content: $content
    sort: $sort
    searchAfter: $searchAfter
    pageSize: $pageSize
  ) {
    searchAfter
    results {
      ...ScheduleFragment
    }
  }
}
    ${ScheduleFragment}
${ServiceCategoryFragment}
${AnnotationFragment}
${ReferenceFragment}`
export const GetSchedulesByProviderIdDocument = `
    query getSchedulesByProviderId($id: String!) {
  searchSchedules(content: [{filter: PROVIDER_ID, value: $id}], pageSize: 5000) {
    results {
      ...ScheduleFragment
    }
  }
}
    ${ScheduleFragment}
${ServiceCategoryFragment}
${AnnotationFragment}
${ReferenceFragment}`
export const GetAppointmentDocument = `
    query getAppointment($id: ID!) {
  getAppointment(_id: $id) {
    ...AppointmentFragment
  }
}
    ${AppointmentFragment}
${ReoccuranceTemplateFragment}
${ServiceCategoryFragment}
${ServiceTypeFragment}
${AnnotationFragment}
${ReferenceFragment}
${VirtualServiceFragment}`
export const SearchAppointmentsDocument = `
    query searchAppointments($content: [SearchFilter!], $sort: [SortParam!], $searchAfter: AWSJSON, $pageSize: Int) {
  searchAppointments(
    content: $content
    sort: $sort
    searchAfter: $searchAfter
    pageSize: $pageSize
  ) {
    searchAfter
    results {
      ...AppointmentFragment
    }
  }
}
    ${AppointmentFragment}
${ReoccuranceTemplateFragment}
${ServiceCategoryFragment}
${ServiceTypeFragment}
${AnnotationFragment}
${ReferenceFragment}
${VirtualServiceFragment}`
export const GetPatientAppointmentsByDateRangeDocument = `
    query getPatientAppointmentsByDateRange($treatmentId: String!, $from: String!, $to: String!, $pageSize: Int) {
  searchAppointments(
    content: [{filter: PATIENT_ID, value: $treatmentId}, {filter: START_DATE, operator: gte, value: $from}, {filter: END_DATE, operator: lte, value: $to}]
    sort: [{field: START_DATE, order: asc}]
    pageSize: $pageSize
  ) {
    searchAfter
    results {
      ...AppointmentFragment
    }
  }
}
    ${AppointmentFragment}
${ReoccuranceTemplateFragment}
${ServiceCategoryFragment}
${ServiceTypeFragment}
${AnnotationFragment}
${ReferenceFragment}
${VirtualServiceFragment}`
export const GetAppointmentsByProviderIdDocument = `
    query getAppointmentsByProviderId($id: String!) {
  searchAppointments(content: [{filter: PROVIDER_ID, value: $id}], pageSize: 5000) {
    results {
      ...AppointmentFragment
    }
  }
}
    ${AppointmentFragment}
${ReoccuranceTemplateFragment}
${ServiceCategoryFragment}
${ServiceTypeFragment}
${AnnotationFragment}
${ReferenceFragment}
${VirtualServiceFragment}`
export const GetNextLastApptByTreatmentIdDocument = `
    query getNextLastApptByTreatmentId($id: String!, $now: String!) {
  getNextApptByPatientId: searchAppointments(
    content: [{filter: PATIENT_ID, value: $id}, {filter: START_DATE, value: $now, operator: gt}]
    sort: [{field: START_DATE, order: asc}]
    pageSize: 1
  ) {
    results {
      _id
      startDate
      endDate
      status
      serviceCategory {
        code
      }
      serviceType {
        code
      }
    }
  }
  getLastApptByPatientId: searchAppointments(
    content: [{filter: PATIENT_ID, value: $id}, {filter: START_DATE, value: $now, operator: lte}]
    sort: [{field: START_DATE, order: desc}]
    pageSize: 1
  ) {
    results {
      _id
      startDate
      endDate
      status
      serviceCategory {
        code
      }
      serviceType {
        code
      }
    }
  }
}
    `

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    createSchedule: build.mutation<
      Types.CreateSchedule,
      Types.CreateScheduleVariables
    >({
      query: (variables) => ({ document: CreateScheduleDocument, variables }),
    }),
    updateSchedule: build.mutation<
      Types.UpdateSchedule,
      Types.UpdateScheduleVariables
    >({
      query: (variables) => ({ document: UpdateScheduleDocument, variables }),
    }),
    deleteSchedule: build.mutation<
      Types.DeleteSchedule,
      Types.DeleteScheduleVariables
    >({
      query: (variables) => ({ document: DeleteScheduleDocument, variables }),
    }),
    createAppointment: build.mutation<
      Types.CreateAppointment,
      Types.CreateAppointmentVariables
    >({
      query: (variables) => ({
        document: CreateAppointmentDocument,
        variables,
      }),
    }),
    updateAppointment: build.mutation<
      Types.UpdateAppointment,
      Types.UpdateAppointmentVariables
    >({
      query: (variables) => ({
        document: UpdateAppointmentDocument,
        variables,
      }),
    }),
    deleteAppointment: build.mutation<
      Types.DeleteAppointment,
      Types.DeleteAppointmentVariables
    >({
      query: (variables) => ({
        document: DeleteAppointmentDocument,
        variables,
      }),
    }),
    createAppointmentV2: build.mutation<
      Types.CreateAppointmentV2,
      Types.CreateAppointmentV2Variables
    >({
      query: (variables) => ({
        document: CreateAppointmentV2Document,
        variables,
      }),
    }),
    updateReoccuranceTemplate: build.mutation<
      Types.UpdateReoccuranceTemplate,
      Types.UpdateReoccuranceTemplateVariables
    >({
      query: (variables) => ({
        document: UpdateReoccuranceTemplateDocument,
        variables,
      }),
    }),
    getSchedule: build.query<Types.GetSchedule, Types.GetScheduleVariables>({
      query: (variables) => ({ document: GetScheduleDocument, variables }),
    }),
    searchSchedules: build.query<
      Types.SearchSchedules,
      Types.SearchSchedulesVariables | void
    >({
      query: (variables) => ({ document: SearchSchedulesDocument, variables }),
    }),
    getSchedulesByProviderId: build.query<
      Types.GetSchedulesByProviderId,
      Types.GetSchedulesByProviderIdVariables
    >({
      query: (variables) => ({
        document: GetSchedulesByProviderIdDocument,
        variables,
      }),
    }),
    getAppointment: build.query<
      Types.GetAppointment,
      Types.GetAppointmentVariables
    >({
      query: (variables) => ({ document: GetAppointmentDocument, variables }),
    }),
    searchAppointments: build.query<
      Types.SearchAppointments,
      Types.SearchAppointmentsVariables | void
    >({
      query: (variables) => ({
        document: SearchAppointmentsDocument,
        variables,
      }),
    }),
    getPatientAppointmentsByDateRange: build.query<
      Types.GetPatientAppointmentsByDateRange,
      Types.GetPatientAppointmentsByDateRangeVariables
    >({
      query: (variables) => ({
        document: GetPatientAppointmentsByDateRangeDocument,
        variables,
      }),
    }),
    getAppointmentsByProviderId: build.query<
      Types.GetAppointmentsByProviderId,
      Types.GetAppointmentsByProviderIdVariables
    >({
      query: (variables) => ({
        document: GetAppointmentsByProviderIdDocument,
        variables,
      }),
    }),
    getNextLastApptByTreatmentId: build.query<
      Types.GetNextLastApptByTreatmentId,
      Types.GetNextLastApptByTreatmentIdVariables
    >({
      query: (variables) => ({
        document: GetNextLastApptByTreatmentIdDocument,
        variables,
      }),
    }),
  }),
})

export { injectedRtkApi as api }
